var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    {
      directives: [
        {
          name: "touch-swipe",
          rawName: "v-touch-swipe.horizontal",
          value: _vm.userHasSwiped,
          expression: "userHasSwiped",
          modifiers: { horizontal: true }
        }
      ]
    },
    [
      _c(
        "transition",
        { attrs: { name: _vm.slideDirection, mode: "out-in" } },
        [
          _c(_vm.currentView, {
            tag: "component",
            attrs: { transName: _vm.slideDirection }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.showNav
        ? _c("nav-btn", { attrs: { goPrev: _vm.goPrev, goNext: _vm.goNext } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a79cc420", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a79cc420","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/switch-view.vue
// module id = null
// module chunks = 